module.exports = {
  'news-promo': { ru: 'Новости и Акции', en: 'Новини та Акції' },
  interesting: { ru: 'Это интересно', en: 'Це цікаво' },
  'pay-secrets': { ru: 'Секреты платежей', en: 'Секрети платежів' }
}
